// Default Program Variables
export const defaultVariables: any = {
    carrier: ["Chubb Insurance Company", "Chubb"],
    policyUrl: "../../../assets/umbrella/Chubb_GPEL_Policy.pdf",
    faqUrl: "https://alliantprivateclient.com/media/ir4fq3nh/group-personal-excess-liability-faqs.pdf",
    supportEmail: "groupexcessliability@alliant.com",
    feeDisclaimer: "All Premiums are subject to 3% California Surplus Lines Tax and 0.25% Stamping Fee (not included in below premiums).",
    displayHowMuchInsurance: true,
    EL_Included: "$1,000,000",
    EL_Disclaimers: [
        "<strong>*</strong>The maximum limit of liability for any participants without their underlying home and auto insurance policies in place with Chubb.",
        `<strong>**</strong>A completed Chubb Group Personal Excess Participant Questionnaire is required for any participant who <u>newly elects</u> or <u>enrolls</u> at these limits, subject to underwriting approval.
        In addition, it is a requirement that your underlying home and automobile coverage be in place with Chubb.
        Current participants enrolled at these limits are grandfathered in at their expiring limits.`
    ],
    UM_Label: "Please select your desired coverage limits for each section below.",
    UM_Disclaimers: [],
    EPLI_Disclaimer: "<strong>*</strong>Any participant who newly elects this coverage is required to complete the Chubb Employment Practice Liability Coverage Request Worksheet.",
    requiredLimits: [
        [
            "Personal Liability:",
            "$300,000 Single Limit"
        ],
        [
            "<div>Personal Automobile Liability:</div><div>Private passenger autos, motor homes, motorcycles and other motor vehicles with less than four wheels (<em>Registered Vehicle</em>)</div>",
            `<div>$300,000 Single Limit <strong>OR</strong></div>
            <div>$250,000 per person / $500,000 accident / $100,000 property damage <strong>OR</strong></div>
            <div>$300,000 per person / $300,000 accident / $100,000 property damage</div>`
        ],
        [
            "<div>Personal Automobile Liability:</div><div>(<em>Unregistered Vehicle</em>)</div>",
            "$300,000 Single Limit (Not Licensed for Road Use)"
        ],
        [
            "Uninsured / Underinsured Motorist Protection:",
            `<div>$300,000 Single Limit<strong> OR</strong></div>
            <div>$250,000 per person / $500,000 accident <strong>OR</strong></div>
            <div>$300,000 per person / $300,000 accident</div>`
        ],
        [
            "<div>Watercraft:</div><div>Less than 26 feet <strong>AND</strong> 50 engine rated HP or less</div>",
            "$300,000 Single Limit"
        ],
        [
            "<div>Watercraft:</div><div>26 feet or longer up to 70 feet or more than 50 engine - rated HP <strong>*</strong></div>",
            "$500,000 Single Limit"
        ]
    ],
    learnMoreUrl: "https://alliantprivateclient.com/media/5fvpkhbx/complimentary-personal-insurance-review-alliant-private-client.pdf"
};

